import { defineComponent } from 'vue'
import type Address from '#models/address'

export default defineComponent({
  props: {
    address: {
      type: Object as () => Address,
      required: true
    }
  }
})
